import styled from 'styled-components';

export const HeaderCell = styled.th`
  vertical-align: middle !important;
`;
